import { render, staticRenderFns } from "./ChurnTrackingBlock.vue?vue&type=template&id=4e5d7f5d&"
import script from "./ChurnTrackingBlock.vue?vue&type=script&lang=ts&"
export * from "./ChurnTrackingBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4e5d7f5d', component.options)
    } else {
      api.reload('4e5d7f5d', component.options)
    }
    module.hot.accept("./ChurnTrackingBlock.vue?vue&type=template&id=4e5d7f5d&", function () {
      api.rerender('4e5d7f5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/util/ChurnTrackingBlock.vue"
export default component.exports